import './link-card.scss';

import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';

import { Link } from '../../atoms/link/link.tsx';
import { cn } from '../../utils/helpers.ts';

export type LinkCardProps = {
  href: string;
  onClick?: () => void;
  className?: string;
  graphic?: React.ReactNode;
  children: React.ReactNode;
};

export const LinkCard: React.FC<LinkCardProps> = ({
  href,
  onClick,
  className,
  graphic,
  children,
}) => {
  return (
    <Link
      href={href}
      onClick={onClick}
      className={cn(
        'LinkCard',
        'flex items-center p-comfy-sm gap-comfy-xs md:gap-comfy-sm rounded-md cursor-pointer no-underline w-full relative',
        className,
      )}
    >
      {graphic && (
        <div className="flex shrink-0 items-center justify-center">
          {graphic}
        </div>
      )}

      <div className="LinkCard__content flex flex-1 flex-col gap-snug-md">
        {children}
      </div>

      <div className="LinkCard__chevron flex shrink-0 items-center">
        <ArkIcon iconName="chevron-right" size="1.25rem" />
      </div>
    </Link>
  );
};
